<template>
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 2000">
		<div style="width: 500px">
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("add-doc") }}</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close', false)" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<div class="dialog-body">
				<div class="container">
					<span>{{ $t("add-document-project") }}</span>
					<div>
						<el-select
							v-model="destinationProjectId"
							:placeholder="$t('projects')"
							style="width: 100%"
							filterable
							remote
							:remote-method="getProjects"
							:loading="loading"
						>
							<el-option-group v-for="project in projects" :key="project.id" :label="project.name">
								<el-option :label="project.name" :value="project.id"></el-option>
								<el-option
									v-for="procedure in project.procedures"
									:key="procedure.id"
									:label="procedure.name"
									:value="procedure.id"
								>
									<md-icon>folder_open</md-icon>
									<span>{{ procedure.name }}</span>
								</el-option>
							</el-option-group>
						</el-select>
					</div>
				</div>
			</div>
			<div class="dialog-footer">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="$emit('close', false)">
						{{ $t("cancel") }}
					</md-button>
					<md-button class="add" @click="save">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ $t("save") }}</span>
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"

export default {
	name: "add-document",
	props: ["show", "docId"],
	data() {
		return {
			loading: false,
			selected: undefined,
			projects: [],
			unique: undefined,
			destinationProjectId: null
		}
	},
	watch: {
		docId() {
			this.getProjects()
		}
	},
	methods: {
		getProjects() {
			this.loading = true
			const payload = {
				pagination: {
					size: 15
				},
				search: "",
				organization_id: this.$route.params.school_id,
				project_id: this.current_folder,
				include_procedures: true
			}
			axios
				.post(`${process.env.VUE_APP_API_URL}/api/projects/get`, payload, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
				.then(({ data: { items = [] } }) => {
					this.projects = items
						.filter(({ project_id }) => !project_id)
						.map(project => ({
							...project,
							procedures: items.filter(
								({ project_id }) =>
									project_id === project.id && project_id !== this.$route.params.folder_id
							)
						}))

					if (this.projects.length === 0 && items.length > 0)
						this.projects = [
							{
								...items[0].project,
								procedures: items
							}
						]
				})
				.finally(() => (this.loading = false))
		},
		save() {
			this.loading = true
			axios
				.post(`${process.env.VUE_APP_API_URL}/api/browse/addToProject`, {project_id: this.destinationProjectId, flowchart: this.docId}, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					this.loading = false
					this.selected = undefined
					this.$emit("close")
				})
				.catch(err => console.error(err))
		}
	}
}
</script>

<style scoped></style>
